import { WindowLocationWrapper } from "../utilities/window_wrapping/WindowLocationWrapper";
import { TrackingCodes } from "./TrackingCodes";
import { TrackingCodesProvider } from "./TrackingCodesProvider";

const LOCAL_DEVELOPMENT_HOSTNAME_WITHOUT_SUBDOMAIN = "lawdepot.com";

export class DomainSpecificTrackingCodesProvider
	implements TrackingCodesProvider
{
	constructor(private readonly windowLocation: WindowLocationWrapper) {
		// do nothing
	}

	provideCodes(): Promise<TrackingCodes> {
		const hostname = this.windowLocation.hostname;
		const hostnameWithoutSubdomain = this.isLocalDevelopmentEnvironment(
			hostname
		)
			? LOCAL_DEVELOPMENT_HOSTNAME_WITHOUT_SUBDOMAIN
			: hostname.substring(hostname.indexOf(".") + 1);

		const trackingCodesFileName = `trackingCodes.${hostnameWithoutSubdomain}.txt`;
		const trackingCodesFileFullUrl = `/common/tracking-codes/${trackingCodesFileName}`;
		return fetch(trackingCodesFileFullUrl)
			.then((response) => response.json())
			.then((trackingCodes) => {
				Object.keys(trackingCodes).forEach((k) => {
					if (trackingCodes[k] === null) delete trackingCodes[k];
				});
				return trackingCodes;
			});
	}

	private isLocalDevelopmentEnvironment(hostname: string): boolean {
		return (
			!hostname.includes(".") ||
			!isNaN(parseInt(hostname.substring(0, hostname.indexOf("."))))
		);
	}
}
